<template>
  <div class="list-layout-box" :class="[{'permit-nav':mobNavShow}]">
    <div class="top-fix-container">
      <back-route-hdr :back-mode="'func'" :cur-hash="'venues'"
                      @handle-back="handleBack()"></back-route-hdr>
      <van-search v-model="searchText" show-action :placeholder="'搜索'+branchVenueTitle" class="bord-btm">
        <template #action></template>
      </van-search>
      <van-dropdown-menu class="custom-tree-filter">
        <!-- 区域筛选 -->
        <van-dropdown-item ref="location">
          <template #title>
            <i class="fa fa-map-marker" :class="locationIds.length ? 'text-danger' : ''">
              <span class="mar-lft-5">区域</span>
            </i>
          </template>
          <div class="bord-ver bg-white">
            <area-filter-cascade :current-areas="locationIds" :room-src="'exclusive'"
                                 @change="changeLocations"></area-filter-cascade>
          </div>
        </van-dropdown-item>
        <van-dropdown-item v-show="roomTypes.length" ref="filter" class="area-container">
          <template #title>
            <i class="fa fa-filter" :class="selectedTypes.length ? 'text-danger' : ''">
              <span class="mar-lft-5">类型</span>
            </i>
          </template>
          <div class="area-tab-container mar-top-10 mar-btm mar-lft-20">
            <van-checkbox-group v-model="selectedTypes">
              <van-cell v-for="ele in roomTypes" :key="ele.value"
                        class="bord-btm" clickable>
                <template #title>
                  <van-checkbox shape="square" icon-size="14px"
                                :name="ele.value">{{ele.label}}
                  </van-checkbox>
                </template>
              </van-cell>
            </van-checkbox-group>
          </div>
          <van-row gutter="20" class="mar-all">
            <van-col span="12">
              <van-button block size="small" class="bord-all" @click="selectedTypes=[]">清除</van-button>
            </van-col>
            <van-col span="12">
              <van-button block size="small" type="primary" @click="handleFilter('filter')">确定</van-button>
            </van-col>
          </van-row>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>

    <div v-if="dataList.length || notInit" class="room-cell-box ctn-mar-md">
      <van-list v-model="loading" :finished="finished"
                finished-text="没有更多了" @load="onLoad">
        <van-checkbox-group v-model="selectedIds">
          <van-cell-group v-for="(data, idx) in dataCells" :key="idx"
                          :title="data.location" class="mar-btm">
            <van-cell v-for="doc in data.list" :key="doc.roomId">
              <template #title>
                <van-checkbox :name="doc.roomId" shape="square" icon-size="14px">
                  <span class="custom-title">{{doc.name}}</span>
                </van-checkbox>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>

    <div v-else>
      <empty-notice :image="'search'" :desc="'暂无'+branchVenueTitle"></empty-notice>
    </div>

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button v-if="selectedIds.length" size="small" class="mar-rgt-5"
                    @click="submitInfo(true)">清空
        </van-button>
        <van-button type="primary" size="small" @click="submitInfo()">确定({{selectedIds.length}})</van-button>
      </div>
      <div class="pad-all-10">
        <van-button icon="arrow-left" size="small" @click="handleBack()">返回</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {exclusiveRoom} from "../../../../../server";
  import {frontConfirm, checkShowPermit} from "../../../../../tools/utils";
  import AreaFilterCascade from "../../../components/AreaFilterCascade";

  export default {
    props: {
      curData: Array,
    },
    components: {
      AreaFilterCascade
    },
    data() {
      return {
        searchText: "",
        dataList: [],
        selectedIds: [],
        pageInfo: {
          pageSize: 20,
          pageNum: 1,
          pages: 1,
        },
        finished: false,
        loading: false,
        notInit: true,
        locationIds: [],
        selectedTypes: [],
      }
    },
    computed: {
      branchVenueTitle() {
        return this.$store.state.formTitles.branchVenues
      },
      dataCells() {
        const obj = {};
        this.dataList.forEach(r => {
          if (obj[r.locationInfo]) {
            obj[r.locationInfo].push(r)
          } else {
            obj[r.locationInfo] = [r]
          }
        });
        return Object.keys(obj).map(k => ({
          location: k,
          list: obj[k]
        }))
      },
      roomTypes() {
        const {exclusiveRoomTypes} = this.$store.state.sysConfig;
        return exclusiveRoomTypes || []
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    watch: {
      searchText(val) {
        this.handleDataList();
      },
    },
    created() {
      this.selectedIds = (this.curData || []).map(e => e.id)
    },
    methods: {
      handleDataList() {
        this.pageInfo.pageNum = 1;
        this.dataList = [];
        this.finished = false;
        this.notInit = true;
        this.onLoad()
      },
      onLoad() {
        this.getDataList(this.pageInfo.pageNum++)
      },
      // 改变区域
      changeLocations(data) {
        // console.log(data)
        this.locationIds = data;
        this.handleFilter('location')
      },
      handleFilter(key) {
        // console.log(this.selectedTypes);
        this.$refs[key].toggle();
        this.handleDataList()
      },
      getDataList(pageNum = 1) {
        !this.loading && UILoader.load();
        exclusiveRoom.queryExclusiveRoom(this, {
          queryFilter: {
            textField: this.searchText,
            pageNum,
            pageSize: this.pageInfo.pageSize,
            roomTypes: this.selectedTypes,
            locationIds: this.locationIds,
          },
        }).then(({searchExclusiveRoom: data = {}}) => {
          this.loading = false;
          UILoader.unload();
          const {exclusiveRoomEdge, pageInfo} = data;
          this.dataList = this.dataList.concat((exclusiveRoomEdge || []).map(e => ({
            ...e.room,
            locationInfo: (e.room.locationList || []).map(e => e.name).join('-'),
          })));
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
          this.notInit = false;
        }).catch(err => {
          this.loading = false;
          this.finished = true;
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
      },
      submitInfo(clear) {
        if (clear) {
          this.selectedIds = [];
          return
        }
        const data = [];
        this.selectedIds.forEach(id => {
          const nDoc = this.curData.find(e => e.id === id) || this.dataList.find(e => e.roomId === id);
          nDoc && data.push({
            id: nDoc.id || nDoc.roomId,
            name: nDoc.name
          })
        });
        this.$emit('change-info', data)
      },
      handleBack() {
        if (this.selectedIds.length === this.curData.length) {
          const concatArr = [...new Set(this.curData.map(e => e.id).concat(this.selectedIds))];
          // 无更改
          if (concatArr.length === this.curData.length) {
            this.$emit('change-info', null);
            return
          }
        }
        frontConfirm({msg: "是否丢弃当前更改？"}, () => {
          this.$emit('change-info', null)
        })
      },
    }
  }
</script>

<style scoped>
</style>
